import { render, staticRenderFns } from "./AddToHib.vue?vue&type=template&id=473ac173&"
import script from "./AddToHib.vue?vue&type=script&lang=js&"
export * from "./AddToHib.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports